<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5">Induction and Safety Related Training</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Manpower Requisition</button> -->
                </div>
            </div>
            <!--end header-->
            
            <div class="row row-replace add-m-b">
                <div class="col-md-4 col-6 col-p"> 
                    <select class="form-control">
                        <option>Select Language</option>
                        <option>English</option>
                        <option>Hindi</option>
                        <option>Telugu</option>
                    </select>
                </div>
                <div class="col-md-6 col-3 top-corner-items col-p"></div>
            </div>


             <div class="row">
                 <div class="col-12">
                        <div class="table-responsive">
                            <table class="table">
                                <tr class="bg-primary text-white">
                                    <th width="100">Sr No.</th>
                                    <th>Name of Training</th>
                                    <th width="150">Action</th>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td> Welcome to Mobilise</td>
                                    <td><a [routerLink]="['/dashboard/player']">Explore</a></td>
                                </tr>
                            </table>
                         </div>

                         <div class="table-responsive">
                            <table class="table">
                                <tr class="bg-primary text-white">
                                    <th width="100">Sr No.</th>
                                    <th>MobiliseSafety Moments & Mental Health</th>
                                    <th width="150">Action</th>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Johnpaul Dimech, regional chair on Mental health and its importance</td>
                                    <td><a [routerLink]="['/dashboard/player']">Mental Health</a></td>
                                </tr>
                            </table>
                         </div>

                         <div class="table-responsive">
                            <table class="table">
                                <tr class="bg-primary text-white">
                                    <th width="100">Sr No.</th>
                                    <th>Defensive Driving Training & Videos</th>
                                    <th width="150">Action</th>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>Defensive Driving</td>
                                    <td><a [routerLink]="['/dashboard/player']">PDF</a></td>
                                </tr>
                            </table>
                         </div>

                    </div>
             </div>
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

